/**
 * Created by Andrey Popov on 30.10.2024
 */

cc.UnhighlightUnit = function () {
    cc.CallFunc.prototype.constructor.call(this, (target) => {
        if (target.highlighter) {
            target.highlighter.unhighlight();
            target.highlighter = undefined;
        }
    });
};

cc.UnhighlightUnit.prototype = Object.assign(Object.create(cc.CallFunc.prototype), {
    constructor: cc.UnhighlightUnit
});